import React from "react";

export const SwivelpoleLogo = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170 35"
    className={props.class}
    style={props.style}
    width={props.width}
    height={props.height}>
    <title>Swivelpole Logo</title>
    <path
      d="M12.7,12.9c-2.7-0.7-3.8-1.2-3.8-2.7s1.1-2.3,3.4-2.3c1.5,0,3,0.5,4.2,1.4l0,0h1.8V5.5l-0.1-0.1
      c-1.9-1-4-1.5-6.2-1.4c-4.9,0-7.8,2.4-7.8,6.6c0,3.6,1.6,5.4,6,6.7l1,0.3c2,0.6,3.5,1,3.5,2.8c0,2-2,2.5-3.7,2.5
      C9.1,23,7.3,22.3,6,21l0-0.2H4.2v4l0.1,0.1c2.1,1.2,4.5,1.9,7,1.8c5.4,0,8.4-2.4,8.4-6.8S17.2,14,12.7,12.9z"
    />
    <polygon
      points="37.4,19.5 34.6,9.7 30.8,9.7 27.7,19.6 25.1,9.7 20.4,9.7 20.4,11.1 25,26.4 29.2,26.4 32.3,16.6
      35.2,26.4 39.5,26.4 44.2,11 44.2,9.7 40.2,9.7 "
    />
    <path
      d="M48.7,2.9C47.2,2.8,46,4,46,5.5l0,0c0,1.5,1.2,2.6,2.7,2.6c1.4,0,2.6-1.1,2.7-2.5c0,0,0,0,0-0.1
      C51.3,4,50.2,2.8,48.7,2.9z"
    />
    <path d="M49.2,9.7h-3v16.7h4.9V12.9C51.1,10.3,50.9,9.7,49.2,9.7z" />
    <polygon points="61.6,20.6 57.6,9.7 53,9.7 53,11.1 59,26.4 63.8,26.4 69.5,11 69.5,9.7 65.3,9.7 " />
    <path
      d="M78.1,9.4c-4.9,0-8.2,3.5-8.2,8.7s3.2,8.5,8.5,8.5c2.3,0.1,4.5-0.5,6.5-1.6l0.1-0.1v-3.3h-1.7h-0.1
      C82,22.5,80.5,23,79,23c-2.7,0-3.8-1.1-4.1-3.8h10.6V19c0,0,0-0.2,0-0.3s0-0.7,0-1.1C85.6,12.3,83,9.4,78.1,9.4z M78.1,12.7
      c1.3,0,2.5,0.4,2.7,3.4h-5.7C75.5,13.1,76.9,12.7,78.1,12.7z"
    />
    <path d="M90.8,4.2h-3v22.2h4.9V7C92.7,4.8,92.5,4.2,90.8,4.2z" />
    <path
      d="M105.5,9.4c-1.8,0-3.5,0.6-4.9,1.7c0-0.8-0.6-1.4-1.4-1.4c0,0,0,0-0.1,0h-3.3v21.8h4.9v-6.2
      c1.2,0.7,2.5,1.1,3.9,1c1.7,0,7.4-0.6,7.4-8.6C112,11.6,108.6,9.4,105.5,9.4z M100.8,14c0.9-0.4,1.9-0.7,2.9-0.7
      c1.4,0,3.3,0.5,3.3,4.7s-1.9,4.7-3.5,4.7c-1,0-1.9-0.2-2.7-0.8C100.7,21.8,100.7,14,100.8,14z"
    />
    <path
      d="M121.8,9.4c-5,0-8.5,3.6-8.5,8.7c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5C130.4,13,126.9,9.4,121.8,9.4z
      M121.8,23c-2.3,0-3.5-1.7-3.5-4.8s1.3-5.1,3.5-5.1s3.5,1.9,3.5,5.1S124.1,23,121.8,23L121.8,23z"
    />
    <path d="M135.5,4.2h-3v22.2h4.9V7C137.5,4.8,137.3,4.2,135.5,4.2z" />
    <path
      d="M147.9,9.4c-4.9,0-8.2,3.5-8.2,8.7s3.2,8.5,8.5,8.5c2.3,0.1,4.5-0.5,6.5-1.6l0.1-0.1v-3.3h-1.7H153
      c-1.2,0.9-2.7,1.4-4.2,1.4c-2.6,0-3.9-1.1-4.1-3.8h10.6V19c0,0,0-0.2,0-0.3s0-0.7,0-1.1C155.4,12.3,152.8,9.4,147.9,9.4z
      M147.9,12.7c1.3,0,2.5,0.4,2.7,3.4h-5.7C145.2,13.1,146.7,12.7,147.9,12.7z"
    />
    <path
      d="M157.6,8.1V4.7h-1.2V3.8h3.7v0.9h-1.2V8h-1.3V8.1z M160.7,8.1V3.8h1.9l0.7,2.3l0,0l0.7-2.3h1.9v4.3h-1.2V4.8
      l0,0l-1,3.2h-0.9l-1-3.2l0,0V8h-1.1V8.1z"
    />
  </svg>
);

export const IconChevronRight = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    className={props.class}
    style={props.style}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
